import type { RatingStats } from "@/lib/ratingStats";

export type SsrPayload = {
  ratingStats?: RatingStats | null;
};

export function readSsrPayload(): SsrPayload | null {
  if (typeof document === "undefined") {
    return null;
  }

  const element = document.getElementById("__SSR_DATA__");
  if (!element?.textContent) {
    return null;
  }

  try {
    return JSON.parse(element.textContent) as SsrPayload;
  } catch {
    return null;
  }
}
